import { Component, EventEmitter, forwardRef, Inject, Input, Output } from '@angular/core';
import { Events } from 'ionic-angular';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { ComponentServiceProvider } from '../../providers/component-service/component-service';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { PriceListTableProvider } from '../../providers/price-list-table/price-list-table';

const DEFAULTVALUE = 0;
@Component({
  selector: 'add-device',
  templateUrl: 'add-device.html'
})
export class AddDeviceComponent {
  headerValues = {
    buttonLabel: [{
      "name": "return",
      "action": 'RETURN_BACKUP_DR'
    },{
      "name": "price list",
      "action": 'priceList'
    }]
  }
  bindSelectedDatto: any = '';
  newObject: any;
  dattoMuMonthly: any = '50%';
  dattoMuDevice: any = '25%';
  parseJson: any;
  AddDeviceHeader: any;
  broadcastSubs: any;
  @Output() returnBack = new EventEmitter<any>();
  @Input() sheetId: any;
  constructor(@Inject(forwardRef(() => ComponentServiceProvider)) public componentService: ComponentServiceProvider,public communicationServ: CommunicationServiceProvider,public dataService: DataServiceProvider,public event: Events, public priceListTableService: PriceListTableProvider) {
    this.newObject = JSON.stringify({
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    });
  }
  ngOnInit() {
    this.goBack();
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER', status: true, params: this.headerValues});
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: ''});
    if (this.sheetId == 'MSPPRICINGSHEET') {
      this.AddDeviceHeader = 'MANAGED IT SERVICES - Backup/DR Sub-Schedule - ' + this.dataService.ProposalTable.mspForm.ClientCompanyName;
      if (localStorage.getItem('AllDatto') != null && localStorage.getItem('AllDatto') != 'undefined') {
        var allDatto = localStorage.getItem('AllDatto');
        this.dataService.ProposalTable.AllDatto = JSON.parse(allDatto);
      } 
      // else {
      //   this.dataService.ProposalTable.AllDatto = this.dataService.ProposalTable.AllDatto);
      // }
      if (localStorage.getItem('AllIntronis') != null && localStorage.getItem('AllIntronis') != 'undefined') {
        var allIntronis = localStorage.getItem('AllIntronis');
        this.dataService.ProposalTable.AllIntronis = JSON.parse(allIntronis);
      } 
      // else {
      //   this.dataService.ProposalTable.AllIntronis = JSON.parse(this.dataService.ProposalTable.AllIntronis);
      // }
      if (localStorage.getItem('SelectedDevices') != null && localStorage.getItem('SelectedDevices') != 'undefined') {
        var val = localStorage.getItem('SelectedDevices');
        this.dataService.ProposalTable.MspDattoIntronis.totalDattoPrice = JSON.parse(val).dattoMonthlyPrice;
        this.dataService.ProposalTable.MspDattoIntronis.totalIntronisPrice = JSON.parse(val).intronisMonthlyPrice;
        this.dataService.ProposalTable.MspDattoIntronis.totalIntronisOneTimePurchase = JSON.parse(val).intronisOneTime;
        this.dataService.ProposalTable.MspDattoIntronis.totalDattoOneTimePurchase = JSON.parse(val).dattoOneTime;
        this.dataService.ProposalTable.MspDattoIntronis.noOfIntronisDevices = JSON.parse(val).intronisConnectedDevices;
        this.dataService.ProposalTable.MspDattoIntronis.noOfDattoDevices = JSON.parse(val).dattoConnectedDevices;
      }
    } else if (this.sheetId == 'BACKUPDRPRICINGSHEET') {
      this.AddDeviceHeader = 'BACKUP D/R Sub-Schedule - ' + this.dataService.ProposalTable.mspForm.ClientCompanyName;
      if (localStorage.getItem('BackupDrAllDatto') != "undefined" && localStorage.getItem('BackupDrAllDatto') != null) {
        var allDatto = localStorage.getItem('BackupDrAllDatto');
        this.dataService.ProposalTable.BackupDrAllDatto = JSON.parse(allDatto);
      }
      //  else {
      //   this.dataService.ProposalTable.AllDatto = JSON.parse(this.dataService.ProposalTable.AllDatto);
      // }
      if (localStorage.getItem('BackupDrAllIntronis') != "undefined" && localStorage.getItem('BackupDrAllIntronis') != null) {
        var allIntronis = localStorage.getItem('BackupDrAllIntronis');
        this.dataService.ProposalTable.BackupDrAllIntronis = JSON.parse(allIntronis);
      } 
      // else {
      //   this.dataService.ProposalTable.AllIntronis = JSON.parse(this.dataService.ProposalTable.AllIntronis);
      // }
      if (localStorage.getItem('BackupDrSelectedDevices') != null && localStorage.getItem('BackupDrSelectedDevices') != 'undefined') {
        var val = localStorage.getItem('BackupDrSelectedDevices');
        this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoPrice = JSON.parse(val).dattoMonthlyPrice;
        this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisPrice = JSON.parse(val).intronisMonthlyPrice;
        this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisOneTimePurchase = JSON.parse(val).intronisOneTime;
        this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoOneTimePurchase = JSON.parse(val).dattoOneTime;
        this.dataService.ProposalTable.BackupDrDattoIntronis.noOfIntronisDevices = JSON.parse(val).intronisConnectedDevices;
        this.dataService.ProposalTable.BackupDrDattoIntronis.noOfDattoDevices = JSON.parse(val).dattoConnectedDevices;
      }
    }
    var priceListData = JSON.parse(localStorage.getItem('Pricelist'));
    if (priceListData != null) {
      this.priceListTableService.priceList.TotalUsExchange =  priceListData.TotalUsExchange;
      this.priceListTableService.priceList.TotalToolsMarkup = priceListData.TotalToolsMarkup;
      priceListData.Intronis.forEach(element => {
        let cdn = (parseFloat(element.newUsd == '' ? element.defUsd.slice(1).replace(/  |,/gi,"") : element.newUsd.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(priceListData.TotalUsExchange.slice(0, -1)) / 100)))
        element.cdn = '$' + cdn.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        element.monthlyPrice = '$' + (cdn * (1 + (parseFloat(element.orMarkup == '' ? priceListData.TotalToolsMarkup.slice(0, -1) : element.orMarkup.slice(0, -1)) / 100))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      });
      priceListData.Datto.DattoSize.forEach(element => {
        var basePrice = (parseFloat(element.newBaseCost != '' ? element.newBaseCost.slice(1).replace(/  |,/gi,"") : element.defBaseCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(priceListData.Datto.newDevicePercent != '' ? priceListData.Datto.newDevicePercent.slice(0, -1) : priceListData.Datto.defDevicePercent.slice(0, -1)) / 100)))
        element.basePrice = '$' + basePrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        var monthlyPrice = (parseFloat(element.newMonthlyCost != '' ? element.newMonthlyCost.slice(1).replace(/  |,/gi,"") : element.defMonthlyCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(priceListData.Datto.newMonthlyPercent != '' ? priceListData.Datto.newMonthlyPercent.slice(0, -1) : priceListData.Datto.defMonthlyPercent.slice(0, -1)) / 100)))
        element.monthlyPrice = '$' + monthlyPrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      });
      this.priceListTableService.priceList.Datto.DattoSize = priceListData.Datto.DattoSize;
      this.priceListTableService.priceList.Intronis = priceListData.Intronis;

    } else {
      this.priceListTableService.priceList.TotalToolsMarkup =  this.priceListTableService.priceList.defToolsMarkup;
      this.priceListTableService.priceList.TotalUsExchange =  this.priceListTableService.priceList.newUsExchange != '' ? this.priceListTableService.priceList.newUsExchange : this.priceListTableService.priceList.defUsExchange;
      this.priceListTableService.priceList.Intronis.forEach(element => {
        let cdn = (parseFloat(element.newUsd == '' ? element.defUsd.slice(1).replace(/  |,/gi,"") : element.newUsd.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.TotalUsExchange.slice(0, -1)) / 100)))
        element.cdn = '$' + cdn.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        element.monthlyPrice = '$' + (cdn * (1 + (parseFloat(element.orMarkup == '' ? this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1) : element.orMarkup.slice(0, -1)) / 100))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      });
      this.priceListTableService.priceList.Datto.DattoSize.forEach(element => {
        var basePrice = (parseFloat(element.newBaseCost != '' ? element.newBaseCost.slice(1).replace(/  |,/gi,"") : element.defBaseCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.Datto.newDevicePercent != '' ? this.priceListTableService.priceList.Datto.newDevicePercent.slice(0, -1) : this.priceListTableService.priceList.Datto.defDevicePercent.slice(0, -1)) / 100)))
        element.basePrice = '$' + basePrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        var monthlyPrice = (parseFloat(element.newMonthlyCost != '' ? element.newMonthlyCost.slice(1).replace(/  |,/gi,"") : element.defMonthlyCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.priceListTableService.priceList.Datto.newMonthlyPercent != '' ? this.priceListTableService.priceList.Datto.newMonthlyPercent.slice(0, -1) : this.priceListTableService.priceList.Datto.defMonthlyPercent.slice(0, -1)) / 100)))
        element.monthlyPrice = '$' + monthlyPrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      });
    }
  }

  goBack(){
    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if(data.src ===  'proposal-create'){
        if(data.event === 'GO_BACK'){
          let status = data['status'];
    if (status == true) {
      let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalCreate')
      var pageContent = this.componentService.tabTemplates[index].templates;
      if (this.sheetId == 'MSPPRICINGSHEET') {
        localStorage.setItem('AllDatto', JSON.stringify(this.dataService.ProposalTable.AllDatto));
        localStorage.setItem('AllIntronis', JSON.stringify(this.dataService.ProposalTable.AllIntronis));
        this.dataService.broadcastInfo({ src: 'proposal-create', event: 'OPEN_PAGE', params: pageContent[1], tab: ''});
      } else if (this.sheetId == 'BACKUPDRPRICINGSHEET') {
        localStorage.setItem('BackupDrAllDatto', JSON.stringify(this.dataService.ProposalTable.BackupDrAllDatto));
        localStorage.setItem('BackupDrAllIntronis', JSON.stringify(this.dataService.ProposalTable.BackupDrAllIntronis));
        this.dataService.broadcastInfo({ src: 'proposal-create', event: 'OPEN_PAGE', params: pageContent[4], tab: ''});
      }
      this.totalDevices();
    }
  }
}
});
  }

  dattoSelected(event, idx) {
    if(this.sheetId == 'MSPPRICINGSHEET'){
      if (event.target.value != '') {
        let index = this.priceListTableService.priceList.Datto.DattoSize.findIndex(elem => elem.device == event.target.value)
        this.dataService.ProposalTable.AllDatto[idx].device = event.target.value;
        this.dataService.ProposalTable.AllDatto[idx].monthlyPrice = this.priceListTableService.priceList.Datto.DattoSize[index].monthlyPrice;
        if (this.dataService.ProposalTable.AllDatto[idx].updateOrNew.toUpperCase() == 'N') {
          this.dataService.ProposalTable.AllDatto[idx].purchasePrice = this.priceListTableService.priceList.Datto.DattoSize[index].basePrice;
        } else if (this.dataService.ProposalTable.AllDatto[idx].updateOrNew.toUpperCase() == 'U') {
          this.dataService.ProposalTable.AllDatto[idx].purchasePrice = '';
        }
        if (this.dataService.ProposalTable.MspDattoIntronis.noOfDattoDevices.includes(idx) != true) {
          this.dataService.ProposalTable.MspDattoIntronis.noOfDattoDevices.push(idx)
        }
      } else {
        this.dataService.ProposalTable.AllDatto[idx].device = event.target.value;
        this.dataService.ProposalTable.AllDatto[idx].monthlyPrice = '';
        this.dataService.ProposalTable.AllDatto[idx].updateOrNew = '';
        this.dataService.ProposalTable.AllDatto[idx].purchasePrice = '';
        const index = this.dataService.ProposalTable.MspDattoIntronis.noOfDattoDevices.indexOf(idx);
        if (index > -1) {
          this.dataService.ProposalTable.MspDattoIntronis.noOfDattoDevices.splice(index, 1);
        }
      }
    }else if (this.sheetId == 'BACKUPDRPRICINGSHEET') {
      if (event.target.value != '') {
        let index = this.priceListTableService.priceList.Datto.DattoSize.findIndex(elem => elem.device == event.target.value)
        this.dataService.ProposalTable.BackupDrAllDatto[idx].device = event.target.value;
        this.dataService.ProposalTable.BackupDrAllDatto[idx].monthlyPrice = this.priceListTableService.priceList.Datto.DattoSize[index].monthlyPrice;
        if (this.dataService.ProposalTable.BackupDrAllDatto[idx].updateOrNew.toUpperCase() == 'N') {
          this.dataService.ProposalTable.BackupDrAllDatto[idx].purchasePrice = this.priceListTableService.priceList.Datto.DattoSize[index].basePrice;
        } else if (this.dataService.ProposalTable.BackupDrAllDatto[idx].updateOrNew.toUpperCase() == 'U') {
          this.dataService.ProposalTable.BackupDrAllDatto[idx].purchasePrice = '';
        }
        if (this.dataService.ProposalTable.BackupDrDattoIntronis.noOfDattoDevices.includes(idx) != true) {
          this.dataService.ProposalTable.BackupDrDattoIntronis.noOfDattoDevices.push(idx)
        }
      } else {
        this.dataService.ProposalTable.BackupDrAllDatto[idx].device = event.target.value;
        this.dataService.ProposalTable.BackupDrAllDatto[idx].monthlyPrice = '';
        this.dataService.ProposalTable.BackupDrAllDatto[idx].updateOrNew = '';
        this.dataService.ProposalTable.BackupDrAllDatto[idx].purchasePrice = '';
        const index = this.dataService.ProposalTable.BackupDrDattoIntronis.noOfDattoDevices.indexOf(idx);
        if (index > -1) {
          this.dataService.ProposalTable.BackupDrDattoIntronis.noOfDattoDevices.splice(index, 1);
        }
      }
    }
    this.TotalDatto();
    this.dattoTotalOneTime();
  }

  intronisSelected(event, idx) {
    if(this.sheetId == 'MSPPRICINGSHEET'){
    if (event.target.value != '') {
      let index = this.priceListTableService.priceList.Intronis.findIndex(elem => elem.device == event.target.value)
      this.dataService.ProposalTable.AllIntronis[idx].device = event.target.value;
      this.dataService.ProposalTable.AllIntronis[idx].monthlyPrice = this.priceListTableService.priceList.Intronis[index].monthlyPrice;
      if (this.dataService.ProposalTable.MspDattoIntronis.noOfIntronisDevices.includes(idx) != true) {
        this.dataService.ProposalTable.MspDattoIntronis.noOfIntronisDevices.push(idx)
      }
    } else {
      this.dataService.ProposalTable.AllIntronis[idx].device = event.target.value;
      this.dataService.ProposalTable.AllIntronis[idx].monthlyPrice = "";
      this.dataService.ProposalTable.AllIntronis[idx].updateOrNew = '';
      this.dataService.ProposalTable.AllIntronis[idx].purchasePrice = '';
      const index = this.dataService.ProposalTable.MspDattoIntronis.noOfIntronisDevices.indexOf(idx);
      if (index > -1) {
        this.dataService.ProposalTable.MspDattoIntronis.noOfIntronisDevices.splice(index, 1);
      }
    }
  }else if(this.sheetId == 'BACKUPDRPRICINGSHEET'){
    if (event.target.value != '') {
      let index = this.priceListTableService.priceList.Intronis.findIndex(elem => elem.device == event.target.value)
      this.dataService.ProposalTable.BackupDrAllIntronis[idx].device = event.target.value;
      this.dataService.ProposalTable.BackupDrAllIntronis[idx].monthlyPrice = this.priceListTableService.priceList.Intronis[index].monthlyPrice;
      if (this.dataService.ProposalTable.BackupDrDattoIntronis.noOfIntronisDevices.includes(idx) != true) {
        this.dataService.ProposalTable.BackupDrDattoIntronis.noOfIntronisDevices.push(idx)
      }
    } else {
      this.dataService.ProposalTable.BackupDrAllIntronis[idx].device = event.target.value;
      this.dataService.ProposalTable.BackupDrAllIntronis[idx].monthlyPrice = "";
      this.dataService.ProposalTable.BackupDrAllIntronis[idx].updateOrNew = '';
      this.dataService.ProposalTable.BackupDrAllIntronis[idx].purchasePrice = '';
      const index = this.dataService.ProposalTable.BackupDrDattoIntronis.noOfIntronisDevices.indexOf(idx);
      if (index > -1) {
        this.dataService.ProposalTable.BackupDrDattoIntronis.noOfIntronisDevices.splice(index, 1);
      }
    }
  }
    this.TotalIntronis();
    this.intronisTotalOneTime();
  }

  addIntronisRow() {
    let newRow = JSON.parse(this.newObject);
    if (this.sheetId == 'MSPPRICINGSHEET') {
      this.dataService.ProposalTable.AllIntronis.push(newRow);
    } else if (this.sheetId == 'BACKUPDRPRICINGSHEET') {
      this.dataService.ProposalTable.BackupDrAllIntronis.push(newRow);
    }
  }
  addDattoRow() {
    let newRow = JSON.parse(this.newObject);
    if (this.sheetId == 'MSPPRICINGSHEET') {
      this.dataService.ProposalTable.AllDatto.push(newRow);
    } else if (this.sheetId == 'BACKUPDRPRICINGSHEET') {
      this.dataService.ProposalTable.BackupDrAllDatto.push(newRow);
    }
  }
  TotalIntronis() {
    if(this.sheetId == 'MSPPRICINGSHEET'){
      let sumArray = [];
      this.dataService.ProposalTable.AllIntronis.forEach(elem => {
        if (elem.monthlyPrice == '') {
          var totalPrice = DEFAULTVALUE
        } else {
          totalPrice = parseFloat(elem.monthlyPrice.slice(1).replace(/  |,/gi,""));
        }
        sumArray.push(totalPrice)
      })
      var value = sumArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      if(value != DEFAULTVALUE){
        this.dataService.ProposalTable.MspDattoIntronis.totalIntronisPrice = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        this.dataService.ProposalTable.MspDattoIntronis.totalIntronisPrice = '';
      }
    }else if(this.sheetId == 'BACKUPDRPRICINGSHEET'){
      let sumArray = [];
      this.dataService.ProposalTable.BackupDrAllIntronis.forEach(elem => {
        if (elem.monthlyPrice == '') {
          var totalPrice = DEFAULTVALUE
        } else {
          totalPrice = parseFloat(elem.monthlyPrice.slice(1).replace(/  |,/gi,""));
        }
        sumArray.push(totalPrice)
      })
      var value = sumArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      if(value != DEFAULTVALUE){
        this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisPrice = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisPrice = '';
      }
    }
  }
  TotalDatto() {
    if(this.sheetId == 'MSPPRICINGSHEET'){
    let sumArray = [];
    this.dataService.ProposalTable.AllDatto.forEach(elem => {
      if (elem.monthlyPrice == '') {
        var totalPrice = DEFAULTVALUE
      } else {
        totalPrice = parseFloat(elem.monthlyPrice.slice(1).replace(/  |,/gi,""));
      }
      sumArray.push(totalPrice)
    })
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.MspDattoIntronis.totalDattoPrice = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.MspDattoIntronis.totalDattoPrice = '';
    }
  }else if(this.sheetId == 'BACKUPDRPRICINGSHEET'){
    let sumArray = [];
    this.dataService.ProposalTable.BackupDrAllDatto.forEach(elem => {
      if (elem.monthlyPrice == '') {
        var totalPrice = DEFAULTVALUE
      } else {
        totalPrice = parseFloat(elem.monthlyPrice.slice(1).replace(/  |,/gi,""));
      }
      sumArray.push(totalPrice)
    })
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoPrice = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoPrice = '';
    }
  }
  }
  totalDevices() {
    if (this.sheetId == 'MSPPRICINGSHEET') {
      let allDevices = {
        "dattoConnectedDevices": this.dataService.ProposalTable.MspDattoIntronis.noOfDattoDevices,
        "dattoOneTime": this.dataService.ProposalTable.MspDattoIntronis.totalDattoOneTimePurchase == undefined ? '' : this.dataService.ProposalTable.MspDattoIntronis.totalDattoOneTimePurchase,
        "intronisConnectedDevices": this.dataService.ProposalTable.MspDattoIntronis.noOfIntronisDevices,
        "intronisOneTime": this.dataService.ProposalTable.MspDattoIntronis.totalIntronisOneTimePurchase == undefined ? '' : this.dataService.ProposalTable.MspDattoIntronis.totalIntronisOneTimePurchase,
        "dattoMonthlyPrice": this.dataService.ProposalTable.MspDattoIntronis.totalDattoPrice == undefined ? '' : this.dataService.ProposalTable.MspDattoIntronis.totalDattoPrice,
        "intronisMonthlyPrice": this.dataService.ProposalTable.MspDattoIntronis.totalIntronisPrice == undefined ? '' : this.dataService.ProposalTable.MspDattoIntronis.totalIntronisPrice
      }
      localStorage.setItem('SelectedDevices', JSON.stringify(allDevices));
    } else if (this.sheetId == 'BACKUPDRPRICINGSHEET') {
      let allBackupDevices = {
        "dattoConnectedDevices": this.dataService.ProposalTable.BackupDrDattoIntronis.noOfDattoDevices,
        "dattoOneTime": this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoOneTimePurchase == undefined ? '' : this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoOneTimePurchase,
        "intronisConnectedDevices": this.dataService.ProposalTable.BackupDrDattoIntronis.noOfIntronisDevices,
        "intronisOneTime": this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisOneTimePurchase == undefined ? '' : this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisOneTimePurchase,
        "dattoMonthlyPrice": this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoPrice == undefined ? '' : this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoPrice,
        "intronisMonthlyPrice": this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisPrice == undefined ? '' : this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisPrice
      }
      localStorage.setItem('BackupDrSelectedDevices', JSON.stringify(allBackupDevices));
    }
    this.returnBack.emit();
  }

  dattoTotalOneTime() {
    if (this.sheetId == 'MSPPRICINGSHEET') {
      let sumArray = [];
      this.dataService.ProposalTable.AllDatto.forEach(elem => {
        if (elem.purchasePrice == '') {
          var totalOneTimePurchasePrice = DEFAULTVALUE
        } else {
          totalOneTimePurchasePrice = parseFloat(elem.purchasePrice.slice(1).replace(/  |,/gi,""));
        }
        sumArray.push(totalOneTimePurchasePrice)
      })
      var value = sumArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      if(value != DEFAULTVALUE){
        this.dataService.ProposalTable.MspDattoIntronis.totalDattoOneTimePurchase = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        this.dataService.ProposalTable.MspDattoIntronis.totalDattoOneTimePurchase = '';
      }
    } else if (this.sheetId == 'BACKUPDRPRICINGSHEET') {
      let sumArray = [];
      this.dataService.ProposalTable.BackupDrAllDatto.forEach(elem => {
        if (elem.purchasePrice == '') {
          var totalOneTimePurchasePrice = DEFAULTVALUE
        } else {
          totalOneTimePurchasePrice = parseFloat(elem.purchasePrice.slice(1).replace(/  |,/gi,""));
        }
        sumArray.push(totalOneTimePurchasePrice)
      })
      var value = sumArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      if(value != DEFAULTVALUE){
        this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoOneTimePurchase = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoOneTimePurchase = '';
      }
    }
  }
  intronisTotalOneTime() {
    if (this.sheetId == 'MSPPRICINGSHEET') {
      let sumArray = [];
      this.dataService.ProposalTable.AllIntronis.forEach(elem => {
        if (elem.purchasePrice == '') {
          var totalOneTimePurchasePrice = DEFAULTVALUE
        } else {
          totalOneTimePurchasePrice = parseFloat(elem.purchasePrice.slice(1).replace(/  |,/gi,""));
        }
        sumArray.push(totalOneTimePurchasePrice)
      })
      var value = sumArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      if(value != DEFAULTVALUE){
        this.dataService.ProposalTable.MspDattoIntronis.totalIntronisOneTimePurchase = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        this.dataService.ProposalTable.MspDattoIntronis.totalIntronisOneTimePurchase = '';
      }
    } else if (this.sheetId == 'BACKUPDRPRICINGSHEET') {
      let sumArray = [];
      this.dataService.ProposalTable.BackupDrAllIntronis.forEach(elem => {
        if (elem.purchasePrice == '') {
          var totalOneTimePurchasePrice = DEFAULTVALUE
        } else {
          totalOneTimePurchasePrice = parseFloat(elem.purchasePrice.slice(1).replace(/  |,/gi,""));
        }
        sumArray.push(totalOneTimePurchasePrice)
      })
      var value = sumArray.reduce(function (a, b) {
        return a + b;
      }, 0);
      if(value != DEFAULTVALUE){
        this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisOneTimePurchase = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisOneTimePurchase = '';
      }
    }
  }
  dattoUpdateNew(event, i) {
    if (this.sheetId == 'MSPPRICINGSHEET') {
      if (event.target.value != '') {
        this.dataService.ProposalTable.AllDatto[i].updateOrNew = event.target.value;
        let index = this.priceListTableService.priceList.Datto.DattoSize.findIndex(elem => elem.device == this.dataService.ProposalTable.AllDatto[i].device)
        if (this.dataService.ProposalTable.AllDatto[i].device && event.target.value.toUpperCase() == 'N') {
          this.dataService.ProposalTable.AllDatto[i].purchasePrice = this.priceListTableService.priceList.Datto.DattoSize[index].basePrice;
        } else if (this.dataService.ProposalTable.AllDatto[i].device && event.target.value.toUpperCase() == 'U') {
          this.dataService.ProposalTable.AllDatto[i].purchasePrice = '';
        }
      }else{
        this.dataService.ProposalTable.AllDatto[i].purchasePrice = '';
      }
    } else if (this.sheetId == 'BACKUPDRPRICINGSHEET') {
      if (event.target.value != '') {
        this.dataService.ProposalTable.BackupDrAllDatto[i].updateOrNew = event.target.value;
        let index = this.priceListTableService.priceList.Datto.DattoSize.findIndex(elem => elem.device == this.dataService.ProposalTable.BackupDrAllDatto[i].device)
        if (this.dataService.ProposalTable.BackupDrAllDatto[i].device && event.target.value.toUpperCase() == 'N') {
          this.dataService.ProposalTable.BackupDrAllDatto[i].purchasePrice = this.priceListTableService.priceList.Datto.DattoSize[index].basePrice;
        } else if (this.dataService.ProposalTable.BackupDrAllDatto[i].device && event.target.value.toUpperCase() == 'U') {
          this.dataService.ProposalTable.BackupDrAllDatto[i].purchasePrice = '';
        }
      }else{
        this.dataService.ProposalTable.BackupDrAllDatto[i].purchasePrice = '';
      }
    }
    this.dattoTotalOneTime();
  }
  intronisPurchasePrice(event, idx) {
    if (this.sheetId == 'MSPPRICINGSHEET') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          var oneTimePurchaseVal = event.target.value.slice(1).replace(/  |,/gi,"");
        } else {
          oneTimePurchaseVal = event.target.value;
        }
            this.dataService.ProposalTable.AllIntronis[idx].purchasePrice = '$' + parseFloat(oneTimePurchaseVal).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.dataService.ProposalTable.AllIntronis[idx].purchasePrice = '';
      }
    } else if (this.sheetId == 'BACKUPDRPRICINGSHEET') {
      if (event.target.value != '') {
        if (event.target.value.includes("$") == true) {
          var oneTimePurchaseVal = event.target.value.slice(1).replace(/  |,/gi,"");
        } else {
          oneTimePurchaseVal = event.target.value;
        }
        this.dataService.ProposalTable.BackupDrAllIntronis[idx].purchasePrice = '$' + parseFloat(oneTimePurchaseVal).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.dataService.ProposalTable.BackupDrAllIntronis[idx].purchasePrice = '';
      }
    }
    this.intronisTotalOneTime();


  }
  intronisUpdateNew(event, idx) {
    if (this.sheetId == 'MSPPRICINGSHEET') {
      if (event.target.value != '') {
        this.dataService.ProposalTable.AllIntronis[idx].updateOrNew = event.target.value;
      } else {
        this.dataService.ProposalTable.AllIntronis[idx].updateOrNew = ''
      }
    } else if (this.sheetId == 'BACKUPDRPRICINGSHEET') {
      if (event.target.value != '') {
        this.dataService.ProposalTable.BackupDrAllIntronis[idx].updateOrNew = event.target.value;
      } else {
        this.dataService.ProposalTable.BackupDrAllIntronis[idx].updateOrNew = ''
      }
    }
  }

  ngOnDestroy() {
    this.broadcastSubs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/components/add-device/add-device.ts